import React from 'react'
import Edit from './actions/edit'
import ResendEmail from './actions/resend-email'
import Delete from '../delete'
import { useAuth } from 'context/auth'
import { ROLE } from 'enums/user'

const idOf = (value) => (value && typeof value === 'object' ? value._id : value)
const ADMIN_ROLES = [ROLE.ADMIN, ROLE.SUPER_ADMIN]

// Mirrors the server rules so refused actions are not offered: the owner row is only
// managed by the owner, and staff cannot manage admins.
export function rowPermissions(currentUser, user) {
  const isSuperAdmin = currentUser?.role === ROLE.SUPER_ADMIN
  const isSelf = String(currentUser?._id) === String(user?._id)
  const isOwner = String(idOf(currentUser?.account?.creator)) === String(user?._id)
  const canManage =
    isSuperAdmin ||
    isSelf ||
    (!isOwner && (ADMIN_ROLES.includes(currentUser?.role) || !ADMIN_ROLES.includes(user?.role)))
  return { canManage, canDelete: canManage && !isOwner }
}

function QuickActionColumn({ user, ...props }) {
  const { currentUser } = useAuth()
  const { canManage, canDelete } = rowPermissions(currentUser, user)
  return (
    <div class='tw-flex-1 tw-min-w-0 tw-items-center tw-hidden md:tw-flex tw-gap-2'>
      {canManage && <ResendEmail user={user} />}
      {canManage && <Edit user={user} {...props} />}
      {canDelete && <Delete user={user} {...props} />}
    </div>
  )
}

export default QuickActionColumn
